`use strict`;

var $ = $ || jQuery.noConflict();

(function (jQuery) {

    function draad_form_render(event, form_id, current_page) {

        handle_active_fields(event, form_id, current_page);

    }

    function handle_active_fields(event, form_id, current_page) {

        const inputs = document.querySelectorAll("#gform_wrapper_" + form_id + " input, #gform_wrapper_" + form_id + " textarea");
        inputs.forEach(function (input) {

            const wrap = input.closest(".gfield");
            const label = document.querySelector(`label[for="${input.id}"]`);

            if (!wrap || !label) {
                return;
            }

            if (input.value !== "") {
                wrap.classList.add("gform--active");
            }

            input.addEventListener("focus", function () {
                const wrap = input.closest(".gfield");
                wrap.classList.add("gform--active");
            });
            input.addEventListener("blur", field_is_active);

        });

    }

    function field_is_active(input) {

        if (!input) {
            return;
        }

        if (input.target) {
            input = input.target;
        }

        const wrap = input.closest(".gfield");
        if (!wrap) {
            return;
        }

        if (!input.value) {
            wrap.classList.remove("gform--active");
        } else {
            wrap.classList.add("gform--active");
        }

    }

    $(document).on("gform_post_render", draad_form_render);

})();